import { Link } from "react-router-dom"
import StarIcon from "./icons/star-icon"
import { langStore } from "@/stores/lang-store"
import { orgSelectBundle } from "@/routes/select/org/org-select-const"

const OrgLinkCard = ({ org, isFavorite, onToggleFavorite, customUrl }) => {
  const { lang } = langStore()
  const cardLang = lang === "es" ? "en" : lang
  const targetUrl =
    customUrl ||
    (org.path ? `/apt/${org.sido_en.toLocaleLowerCase()}/${org.path}/overview` : undefined)
  const isLinkable = !!targetUrl
  const Container = isLinkable ? Link : "div"
  const favoriteId = org.apt_id || org.id

  const handleFavoriteClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    onToggleFavorite(favoriteId)
  }

  const displayName = org.name?.[cardLang] || org?.["name_" + cardLang]
  let displayLabel = ""

  if (org.category) {
    displayLabel = orgSelectBundle?.filter?.categories?.[org.category]?.[lang] || org.category
  } else {
    displayLabel = org?.["sido_" + cardLang] || org.sido
  }

  let displaySubText = ""

  if (org.region) {
    displaySubText = org.region?.[cardLang] || org.region
  } else {
    const sgg = org?.["sgg_" + cardLang] || org.sgg || ""
    const road = org?.["road_" + cardLang] || org.road || ""
    displaySubText = `${sgg} ${road}`.trim()
  }

  return (
    <Container
      to={targetUrl}
      className={`
        p-5 bg-white rounded-2xl border border-slate-100 shadow-sm relative transition-all group
        ${isLinkable ? "hover:border-blue-500 hover:shadow-md cursor-pointer" : "cursor-default"}
      `}
    >
      <button
        onClick={handleFavoriteClick}
        className="absolute top-4 right-4 z-10 p-1 rounded-full hover:bg-slate-50 transition-colors"
      >
        <span
          className={`text-2xl ${isFavorite ? "text-yellow-400" : "text-slate-200 group-hover:text-slate-300"}`}
        >
          <StarIcon />
        </span>
      </button>

      <div
        className="text-[11px] font-black mb-2 uppercase tracking-wider"
        style={{ color: org.color }}
      >
        ● {displayLabel}
      </div>

      <h3
        className={`font-bold text-lg mb-1 transition-colors ${isLinkable ? "group-hover:text-blue-600" : "text-slate-800"}`}
      >
        {displayName}
      </h3>
      <p className="text-slate-400 text-sm">{displaySubText}</p>

      {org.logo && (
        <img
          src={org.logo}
          alt=""
          style={{ height: org.logoHeight + "px" }}
          className="absolute w-auto object-contain opacity-60 grayscale group-hover:grayscale-0 right-2 bottom-2"
        />
      )}
    </Container>
  )
}

export default OrgLinkCard
